import { gql } from '@apollo/client';

export const READ_CUSTOMER_PMCS_DETAILS = gql`
  query ReadCustomerPmcsDetails($input: CustomerPmcsInput!) {
    readCustomerPmcs(input: $input) {
      pmcId
      logo
      link
      countryCode
      name
      reservationType
      physicalZoneUid
      salesLocationUid
      parkingSpaceType
      countryCode
      visibility
      permitUsageType
      maxLicensePlatesPerQuantity
      prices {
        annualPrice
        thirtyDayPrice
        monthlyPrice
        halfYearPrice
        quarterlyPrice
        validity {
          validFrom
        }
        serviceFee
      }
      billingInterval
      billingTypes
      availability {
        availability
        details {
          pmc
        }
      }
      parkZone {
        name
        uid
        spotMap
      }
      salesLocation {
        uid
        name
        parkingZones
      }
      permitType
      paymentMethods
      parkingSpacesV2 {
        content {
          parkingSpaceUid
          pmcIdRef
          parkingSpaceStatus
          parkingSpace {
            reserved
            name
            type
            uid
            externalNote
            blocked
          }
        }
      }
      billingIntervals
      onlineBookingFlexibleStartDate
      startSellingDate
      endSellingDate
      forResidentsOnly
      vendorId
      enableWaitingList
      attachmentPolicy
      automaticOnlineOrderActivation
      expirationLimits {
        waitingListActivationPermitLock
      }
    }
  }
`;
